"use client";
import { useMemo } from "react";

import { useMobileContentResource } from "../../../core/resource/MobileResourceProvider";
import ProductBarChart from "../ProductBarChart/ProductBarChart";
import { ProductBarChartTransaction } from "../ProductBarChart/types";
import { ViewType } from "../types";
import { Top5PropertiesTransactionsResult } from "./types";

type Props = {
  data: Top5PropertiesTransactionsResult;
  viewType?: ViewType;
  interactive?: boolean;
};

export default function HotelTopSpending({
  data,
  viewType,
  interactive,
}: Props) {
  const { CorporateTransactionDataAnalytics: cr } = useMobileContentResource();

  const transactions: ProductBarChartTransaction[] = useMemo(
    () =>
      data.top5PropertiesTransactions.transactions.map((t) => ({
        month: t.month,
        year: t.year,
        quarter: t.quarter,
        sortDate: t.roundedDownTransactionDate,
        entries: t.properties.map((p) => ({
          name: p.propertyName,
          value: p.amount,
        })),
      })),
    [data]
  );

  return (
    <ProductBarChart
      transactions={transactions}
      note={cr.inBillions}
      viewType={viewType}
      interactive={interactive}
    />
  );
}
